const endpointTypes = {
    GRAPHQL: 'GRAPHQL',
    GRAPHQL_FORCED: 'GRAPHQL_FORCED',
    REST: 'REST',
    REST_CACHED: 'REST_CACHED',
    WEBSOCKET: 'WEBSOCKET',
    MQTT: 'MQTT',
    TEST: 'TEST'
};

export default endpointTypes;
